<template>
  <b-row>
    <b-col sm="6" lg="6" xl="4" class="col-xxl-3" v-bind:key="index" v-for="(item, index) in fields">
      <modal-select v-if="item.type!=='date' && item.type!=='text'" :modal="item.modal" :name="item.field" :readonly="false" v-on:select-item="selectItem($event, item.field, item.foreign)" :placeholder="item.placeholder" label="" ></modal-select>
      <b-form-fieldset v-if="item.type=='date'" >
         <b-input-group  >
          <template v-slot:append>
            <b-button variant="success" v-on:click="textFilter($event, item)"><i class="fa fa-search"></i></b-button>
            <b-button variant="danger" v-on:click="clearFilter($event, item)"><i class="fa fa-times"></i></b-button>
          </template>
          <b-form-input :name="item.field" :placeholder="item.placeholder" v-model="item.val"  />
        </b-input-group>
      </b-form-fieldset>
      <b-form-fieldset v-if="item.type=='text'" >
         <b-input-group  >
          <template v-slot:append>
            <b-button variant="success" v-on:click="textFilter($event, item)"><i class="fa fa-search"></i></b-button>
            <b-button variant="danger" v-on:click="clearFilter($event, item)"><i class="fa fa-times"></i></b-button>
          </template>
          <b-form-input :name="item.field" :placeholder="item.placeholder" v-model="item.val"  />
        </b-input-group>
      </b-form-fieldset>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'grid-filters',
  props: ['fields', 'gridData'],
  data() {
    return {
      filters: {},
      showModal: false,
      item: {
        id: null,
        label: ''
      }
    }
  },
  methods: {
    selectItem(e, field, foreign) {
      if(e.item) {
        this.filters[field] = e.item[foreign]
        this.$parent.$refs[this.gridData].applyFilter(field, e.item[foreign])
      } else {
        this.filters[field] = null
        this.$parent.$refs[this.gridData].removeFilter(field)
      }
    },
    textFilter(a, item) {
      if(item.val) {
        let filterType = item.filterType || 'eq'
        this.filters[item.field] = item.val
        this.$parent.$refs[this.gridData].applyFilter(item.field, item.val, filterType)
      } else {
        this.filters[item.field] = null
        this.$parent.$refs[this.gridData].removeFilter(item.field)
      }
    },
    clearFilter(a, item) {
      console.log(a, item)
      item.val = ''
      this.filters[item.field] = null
      this.$parent.$refs[this.gridData].removeFilter(item.field)

    }
  },
  mounted() {
    // this.$refs.input.value = this.item.id;
  },
  created() {
    this.item.id = typeof this.itemId == 'undefined' ? '': this.itemId
    this.item.label = this.itemName
  }
}
</script>
